import { Component, OnInit, NgZone, OnDestroy } from "@angular/core";
import MediaQueries from '../util/media-queries-helper';

declare var $: any;

@Component({
    selector: 'press-page',
    templateUrl: './press-page.component.html',
    styleUrls: ['./press-page.component.scss']
})
export class PressPageComponent implements OnInit, OnDestroy {

    public elm = document.getElementById("navbar");
    public elm2 = document.getElementById("myNavbar");
    public tabMenu = document.getElementById("tabMenu");

    constructor(private _NgZone: NgZone) {

        if ($(window).width() < 1081) {
            this.elm.style.background = 'linear-gradient(to right, #181818 , #292929, #353333, #504D4D)';
            this.elm2.style.background = 'rgba(53, 51, 51, 0.8)';
            const html = "<li _ngcontent-c1 class='details'><a _ngcontent-c1 routerLink='/home' ng-reflect-router-link='/home' href='/home' class='tab' id='tabName'>HOME</a></li>";
            this.tabMenu.insertAdjacentHTML('afterbegin', html);
        } else {
            this.elm.style.background = 'transparent';
        }

        MediaQueries.matcheQuery("xl").addListener((/*mql: MediaQueryList*/) => {
            _NgZone.run(() => {
                if (MediaQueries.querySelect() == 'xl') {
                    this.elm.style.background = 'transparent';
                } else {
                    this.elm.style.background = 'linear-gradient(to right, #181818 , #292929, #353333, #504D4D)';
                    this.elm2.style.background = 'rgba(53, 51, 51, 0.8)';
                    const html = "<li _ngcontent-c1 class='details'><a _ngcontent-c1 routerLink='/home' ng-reflect-router-link='/home' href='/home' class='tab' id='tabName'>HOME</a></li>";
                    this.tabMenu.insertAdjacentHTML('afterbegin', html);
                }
            });
        });
    }

    ngOnInit() { }

    ngOnDestroy(): void {
        this.elm.style.background = 'transparent';
        this.elm2.style.backgroundColor = 'transparent';

        var tabName = document.getElementById("tabName");
        if (tabName) {
            document.getElementById("tabName").remove();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/press-page/press-page.component.ts